<div class="page-container">
  <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo">

  <app-loader *ngIf="isCheckingToken"></app-loader>

  <ng-container *ngIf="!isCheckingToken && isTokenValid && !success">
    <div class="header">
      <h2>Vergib ein neues Passwort</h2>
      <p translate>Bitte gebe dein neues Passwort ein.</p>
    </div>
    <form [formGroup]="form!">
      <app-text-input formControlName="password" [control]="getControl('password')" [type]="'password'" [label]="'Dein neues Passwort' | translate" [placeholder]="'Gib dein neues Passwort ein' | translate"></app-text-input>
      <app-button [text]="'Passwort ändern'" [loading]="isLoading" (clickEvent)="changePassword()"></app-button>
    </form>
  </ng-container>

  <app-success-screen *ngIf="isTokenValid && success" [title]="'Passwort erfolgreich zurückgesetzt!'" [message]="'Du kannst dich jetzt mit deinem neuen Passwort anmelden'" [buttonText]="'Zum Login'" (buttonClicked)="goToLogin()"></app-success-screen>
  <app-success-screen *ngIf="!isCheckingToken && !isTokenValid" [icon]="'fa-circle-xmark'" [color]="'error'" [title]="'Link ungültig oder abgelaufen'" [message]="'Ups! Der Link ist nicht mehr gültig. Fordere einen neuen Link an.'" [buttonText]="'Neuen Link anfordern'" (buttonClicked)="requestNewLink()"></app-success-screen>
</div>